import paginateArray from './paginateArray'

const functions = {
  paginateArray,
}

export default functions
